import React from "react";
import outerImg from "../assets/outro-public2.jpeg";
import largeOutro from "../assets/flipbook/extraLarge/Outro.jpeg";
import { getOptimizedAssets } from "../utils/helpers";

const OutroImage = ({ isEdged = false, isPdf }) => {
  return (
    <div
      style={{
        backgroundImage: `url(${getOptimizedAssets([outerImg, outerImg, outerImg, outerImg])})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
      className={`w-full h-full outro-image ${!isEdged ? " rounded-xl " : ""} ${isPdf ? "h-[100svh] bg-white" : ""}`}
    >
      <img
        src={outerImg}
        className={`w-full h-full ${!isEdged ? " rounded-xl " : ""}`}
      />
    </div>
  );
};

export default OutroImage;
